import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router} from '@angular/router';
import { CustomValidators } from 'ng2-validation';
import { environment } from 'environments/environment.prod';
const breadcrumb: any[] = [
  {
    title: 'Home'
 
  },
  {
    title: 'Forcast stock control'

  }
];

@Component({
  selector: 'page-stock-planning',
  templateUrl: './stock-planning.html',
  styleUrls: ['./stock-planning.scss']
})

export class PageStockPlainning implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  stateCtrl: FormControl;
  filteredStates: any;
  rows = [];
  temp = [];
  btnCheck=false;
  productModels=[];
  public form: FormGroup;
  key:any;
  loadingIndicator: boolean = true;
  data:any;
  product:string;
  partno:string;
  tbf59_id:string;
  tbf59_date:string;
  tbf59_target:string;
  tbf59_hose="0";
  tbf59_cutting="0";
  tbf59_worktime:string;
  tbf59_std_stock:string;
  tb42_bom_fg_tbf42_id:string;


    //diaglog
    dialogRef: MdDialogRef<ConfirmStockPlanningDialog>;
    selectedOption: string;

    sysPathPrint:String=environment.sysPath+"/api/stock-plan-list-print.php";
    sysPathExport:String=environment.sysPath+"/api/stock-plan-list-export.php";
    date_selected:any;dateTime:any;
  constructor( private fb: FormBuilder,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
    this.dateTime = Date.now();
    let date = new Date();
    this.tbf59_date = date.toISOString().split('T')[0];

    this.fetchBom((productModel) => {
      this.productModels = productModel.map(function (val) {
        return [val.tp_part_no]
      });
      console.log('------this.product------', this.productModels);
    });


    this.stateCtrl = new FormControl();
    this.filteredStates = this.stateCtrl.valueChanges
    .startWith(null)
    .map(name => this.filterStates(name));

   // console.log('-------this.filteredStates-----',this.filteredStates);
    
    this._sharedService.emitChange(this.pageTitle);

    this.fetch((data) => {
      // cache our list
      this.temp = [...data];
      console.log('------data------',data);
      this.rows = data;
      this.loadingIndicator = false;
      setTimeout(() => { this.loadingIndicator = false; }, 1500);
    });
  }

  fetchBom(cb){
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_bom_fg_model.php');

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }



  fetch(cb) {
 
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_std_stock.php');

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }



  filterStates(val: string) {
   
    this.key=val;
 console.log('------val------',this.key);

    return val ? this.productModels.filter((s) => new RegExp(val, 'gi').test(s)) : this.productModels;
  }

  delete(tbf59_id:string){
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/deleteStockPlanning.php?tbf59_id='+tbf59_id);

    req.onload = () => {

      let dialogRef = this.dialog.open(ConfirmStockPlanningDialog);
      let instance = dialogRef.componentInstance;

      console.log('responese----',JSON.parse(req.response).error);
      if(!JSON.parse(req.response).error){
       // alert('add error');
        instance.Title = "Message";
        instance.Message = "Delete data success..";
      }else{
       // alert('add success');
        instance.Title = "Message";
        instance.Message = "Delete data false!";
        
      }

    };

    req.send();

    //this.rows=[];
    for(let i=0;i<2;i++){
      this.fetch((dataSent) => {
        // cache our list
        this.temp = [...dataSent];
        console.log('------data------',dataSent);
        this.rows = dataSent;
        setTimeout(() => { this.loadingIndicator = false; }, 0);
      });
    }
  }

  
  postString() {
   
    let dialogRef = this.dialog.open(ConfirmStockPlanningDialog);
    let instance = dialogRef.componentInstance;
    // this.data = "warehouse="+data;
    this.data = "tbf59_cutting="+this.form.controls.tbf59_cutting.value+"&tbf59_hose="+this.form.controls.tbf59_hose.value+"&tbf59_date="+this.form.controls.tbf59_date.value+"&tbf59_target="+this.tbf59_target+"&tbf59_worktime="+this.tbf59_worktime+"&product="+this.key[0];
     const req = new XMLHttpRequest();
     req.open('POST',  environment.url+'/api/insertDataStockStd.php', true);
     //Send the proper header information along with the request
     req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
     req.onreadystatechange = function () {//Call a function when the state changes.
       if (req.readyState == XMLHttpRequest.DONE && req.status == 200) {
         // Request finished. Do processing here.
         req.onload = () => {
           //console.log(JSON.parse(req.response));

          console.log('responese----',JSON.parse(req.response));
          if(!JSON.parse(req.response).error){
           // alert('add error');
            instance.Title = "Message";
            instance.Message = "Add data success..";
            
            
          }else{
           // alert('add success');
            instance.Title = "Message";
            instance.Message = "Add data exist!";
            
          }
           //JSON.parse(req.response);
         };
       }
     }
     req.send(this.data);
     console.log('data : ',this.data);
     

    this.partno=null;
    //this.tbf59_date=null;
    this.tbf59_target=null;
    this.tbf59_worktime=null;
    this.tbf59_worktime="0";
    this.tbf59_cutting="0";
    this.tbf59_id=null;
    
   // this.rows=[];
    for(let i=0;i<2;i++){
      this.fetch((dataSent) => {
        // cache our list
        this.temp = [...dataSent];
        console.log('------data------',dataSent);
        this.rows = dataSent;
        setTimeout(() => { this.loadingIndicator = false; }, 0);
      });
    }


    
   
   }

   editString(tbf59_hose:string,tbf59_id:string,tbf59_date:string,tbf59_target:string,tbf59_worktime:string,product:string,tbf59_cutting:string){
    this.partno=product;
    this.tbf59_date=tbf59_date;
    this.tbf59_target=tbf59_target;
    this.tbf59_worktime=tbf59_worktime;
    this.tbf59_cutting=tbf59_cutting;
    this.tbf59_hose = tbf59_hose;
    this.tbf59_id=tbf59_id;
    this.btnCheck=true;
   }

   editSave() {
    
        let dialogRef = this.dialog.open(ConfirmStockPlanningDialog);
        let instance = dialogRef.componentInstance;
        // this.data = "warehouse="+data;
        //alert(this.key[0].length);
        if(this.key[0].length!=1){
          this.product = this.key[0];
        }else{
          this.product = this.partno;
        }
         this.data = "tbf59_cutting="+this.form.controls.tbf59_cutting.value+"&tbf59_hose="+this.form.controls.tbf59_hose.value+"&tbf59_id="+this.tbf59_id+"&tbf59_date="+this.form.controls.tbf59_date.value+"&tbf59_target="+this.form.controls.tbf59_target.value+"&tbf59_worktime="+this.form.controls.tbf59_worktime.value+"&product="+this.product;
         const req = new XMLHttpRequest();
         req.open('POST',  environment.url+'/api/editDataStockStd.php', true);
         //Send the proper header information along with the request
         req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
         req.onreadystatechange = function () {//Call a function when the state changes.
           if (req.readyState == XMLHttpRequest.DONE && req.status == 200) {
             // Request finished. Do processing here.
             req.onload = () => {
               //console.log(JSON.parse(req.response));
    
              console.log('responese----',JSON.parse(req.response).error);
              if(!JSON.parse(req.response).error){
               // alert('add error');
                instance.Title = "Message";
                instance.Message = "Edit data success..";
              }else{
               // alert('add success');
                instance.Title = "Message";
                instance.Message = "Edit data false!";
                
              }
               //JSON.parse(req.response);
             };
           }
         }
         req.send(this.data);
         console.log('data : ',this.data);
         
         for(let i=0;i<2;i++){
          this.fetch((dataSent) => {
            // cache our list
            this.temp = [...dataSent];
            console.log('------data------',dataSent);
            this.rows = dataSent;
            setTimeout(() => { this.loadingIndicator = false; }, 0);
          });
        }

        this.partno="";
        this.tbf59_date="";
        this.tbf59_target="";
        this.tbf59_worktime="";
        this.tbf59_cutting="0";
        this.tbf59_hose="0";
        this.tbf59_id="";
        this.btnCheck=false;
       }

  ngOnInit() {

    this.form = this.fb.group({
        //stateCtrl: [null, Validators.compose([Validators.required])],
       // model: [null, Validators.compose([Validators.required])],
       // partname: [null, Validators.compose([Validators.required])],
        //partno: [null, Validators.compose([Validators.required])],
       // max: [null, Validators.compose([Validators.required])],
        //min: [null, Validators.compose([Validators.required])],
        //type: [null, Validators.compose([Validators.required])],
        //spec: [null, Validators.compose([Validators.required])],
        //price: [null, Validators.compose([Validators.required])],
        tbf59_target: [null, Validators.compose([Validators.required])],
        tbf59_worktime:[null, Validators.compose([Validators.required])],
        tbf59_hose:[null, Validators.compose([Validators.required])],
        tbf59_cutting:[null, Validators.compose([Validators.required])],
        //color: [null, Validators.compose([Validators.required])],
        // unit: [null, Validators.compose([Validators.required])]
        //email: [null, Validators.compose([Validators.required, CustomValidators.email])],
        //range: [null, Validators.compose([Validators.required, CustomValidators.range([5, 9])])],
        //url: [null, Validators.compose([Validators.required, CustomValidators.url])],
        tbf59_date: [null, Validators.compose([Validators.required, CustomValidators.date])],
        //creditCard: [null, Validators.compose([Validators.required, CustomValidators.creditCard])],
        //phone: [null, Validators.compose([Validators.required, CustomValidators.phone('en-US')])],
        //gender: [null, Validators.required],
        //password: password,
        //confirmPassword: confirmPassword
        
  
      });


  }

  updateFilter_date(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {
      return d.tbf59_date.toLowerCase().indexOf(val) !== -1 || !val;
    });
    this.rows = temp;
  }
  updateFilter_customer(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {
      return d.tp_customer.toLowerCase().indexOf(val) !== -1 || !val;
    });
    this.rows = temp;
  }
  updateFilter_part_no(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {
      return d.tp_part_no.toLowerCase().indexOf(val) !== -1 || !val;
    });
    this.rows = temp;
  }
  
    openDialog() {
    
    let dialogRef = this.dialog.open(ConfirmStockPlanningDialog);
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      
      if(result==='1'){
 
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }

    });
  }


}
//dialog
@Component({
  selector: 'stock-dialog',
  templateUrl: 'stock-dialog.html',
})
export class ConfirmStockPlanningDialog {
  Message:string;
  Title:string;
  constructor(public dialogRef: MdDialogRef<ConfirmStockPlanningDialog>) {}
}




// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/stock/stock-planning.ts